import { render, staticRenderFns } from "./PasswordRegistrationPage.vue?vue&type=template&id=4c571132"
import script from "./PasswordRegistrationPage.vue?vue&type=script&lang=js"
export * from "./PasswordRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports